import { render } from "./Story.vue?vue&type=template&id=fc003da6&scoped=true"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"

import "./Story.vue?vue&type=style&index=0&id=fc003da6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc003da6"]])

export default __exports__